import './Header.css'
import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';


const active = (name, location) => (
    location.pathname === name ? "active" : ""
)

const doScrolling = (elementY, duration) => { 
    var startingY = window.pageYOffset  
    var diff = elementY - startingY  
    var start

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp
      // Elapsed miliseconds since start of scrolling.
      var time = timestamp - start
      // Get percent of completion in range [0, 1].
      var percent = Math.min(time / duration, 1)
  
      window.scrollTo(0, startingY + diff * percent)
  
      // Proceed with animation as long as we wanted it to.
      if (time < duration) {
        window.requestAnimationFrame(step)
      }
    })
  }


const scrollToMain = () => {
    if(window.innerWidth < 1024){
        let main = document.getElementById("Main")
        let yPosition = main.getBoundingClientRect().top + window.scrollY;
        doScrolling(yPosition, 500)
    }
}

const HeaderLink = (props) => (
    <h3 className={"Section-Link " + active("/"+props.path, props.location)}>
        <Link to={props.path} onClick={scrollToMain}>{props.title}</Link>
    </h3>
)

const Logo = () => (
    <div className="Logo-Container">
        <h1 className="Title"><Link to='/'>Clínica Dental Balmes</Link></h1>
    </div>
)

const SectionsList = ({location}) => (
    <div className="Sections-Container">
        <HeaderLink path=''             title="Inicio"       location={location} />
        <HeaderLink path='servicios'    title='Servicios'    location={location} />
        <HeaderLink path='clinica'      title='La clínica'   location={location} />
        <HeaderLink path='localizacion' title='Localización' location={location} />
        <HeaderLink path='contacto'     title='Contacto'     location={location} />
    </div>
)

const Contact = () => (
    <div className="Contact-Container">
        <ul className="Contact-List">
            <li className="Contact-Item">Av. Balmes 61-69 1º</li>
            <li className="Contact-Item">08700 Igualada (Barcelona)</li>
            <li className="Contact-Item">Tel: 93.805.29.69</li>
        </ul>
    </div>
)

const TheHeader = ({location}) => (
    <div className="Header">
        <Logo />
        <SectionsList location={location} />
        <Contact />
    </div>   
)

const Header = () => (
    <Switch>
        <Route component={TheHeader} />
    </Switch>
)
export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js